/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useMemo, useState } from 'react';

import { Button, CircularProgress, Divider, Grid, MenuItem, Paper, Snackbar, TextField, Typography } from '@material-ui/core';
import { Alert, Autocomplete } from '@material-ui/lab';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';

import Layout from 'containers/layouts/layout';
import { Container } from 'styles/general';
import Environment from 'utils/environments';

const environments = Environment(process.env.REACT_APP_ENV);

function BackOfficeV2({ userInfo }) {
  const allowedUsers = useMemo(() => ['marceloadmin', 'marcioadmin', 'fabricioadmin'], []);
  const currentUser = userInfo?.user;
  const accessAllowed = allowedUsers.includes(String(currentUser || '').toLowerCase());

  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);

  const defaultStart = moment().subtract(14, 'days').format('YYYY-MM-DD');
  const defaultEnd = moment().format('YYYY-MM-DD');
  const [days, setDays] = useState('14');
  const [orderId, setOrderId] = useState('');
  const [dateStart, setDateStart] = useState(defaultStart);
  const [dateEnd, setDateEnd] = useState(defaultEnd);

  const [loading, setLoading] = useState({ list: false, cmv: false, order: false, costs: false });
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
  const [now, setNow] = useState(Date.now());

  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const axiosConfig = {
    headers: {
      User: `${userLocal?.user || currentUser || ''}`
    }
  };

  useEffect(() => {
    if (!accessAllowed) return;
    setLoading((prev) => ({ ...prev, list: true }));
    axios
      .get(`${environments.restaurants}/companies?page=0&size=200`, axiosConfig)
      .then((response) => {
        const content = response?.data?.content || response?.data || [];
        setRestaurants(content);
        setLoading((prev) => ({ ...prev, list: false }));
      })
      .catch(() => {
        setRestaurants([]);
        setLoading((prev) => ({ ...prev, list: false }));
        setToast({ open: true, message: 'Erro ao carregar restaurantes', severity: 'error' });
      });
  }, [accessAllowed]);

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  // Ensure restaurant id helpers are defined before using in cooldown keys
  const getRestaurantId = (obj) => {
    if (!obj) return '';
    return obj?.id ?? obj?.restaurantId ?? obj?._id ?? '';
  };
  const selectedRestaurantId = getRestaurantId(selectedRestaurant);

  const COOLDOWN_MS = 10 * 60 * 1000; // 10 minutes
  const CMV_KEY_BASE = 'bloom_bo_v2_cmv';
  const ORDER_KEY_BASE = 'bloom_bo_v2_order';
  const COSTS_KEY_BASE = 'bloom_bo_v2_costs';

  const getLastTs = (key) => {
    const v = sessionStorage.getItem(key);
    return v ? parseInt(v, 10) : 0;
  };
  const isCooldownActive = (key) => {
    const last = getLastTs(key);
    return last && Date.now() - last < COOLDOWN_MS;
  };
  const getRemainingMs = (key) => {
    const last = getLastTs(key);
    return Math.max(0, COOLDOWN_MS - (Date.now() - last));
  };
  const formatRemaining = (ms) => {
    const totalSeconds = Math.ceil(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}m ${seconds}s`;
  };

  // Use global keys (not per-restaurant) to maintain cooldown across restaurant changes
  const cmvCooldown = isCooldownActive(CMV_KEY_BASE);
  const orderCooldown = isCooldownActive(ORDER_KEY_BASE);
  const costsCooldown = isCooldownActive(COSTS_KEY_BASE);
  const cmvRemainingMs = getRemainingMs(CMV_KEY_BASE);
  const orderRemainingMs = getRemainingMs(ORDER_KEY_BASE);
  const costsRemainingMs = getRemainingMs(COSTS_KEY_BASE);
  const isValidRestaurant = String(selectedRestaurantId).trim().length > 0;
  const isValidDays = /^(?!0$)\d+$/.test(String(days || '').trim());
  const isValidOrderId = String(orderId || '').trim().length > 0;
  const isValidDateRange = String(dateStart || '').trim().length > 0 && String(dateEnd || '').trim().length > 0;

  const handleCmv = () => {
    if (!selectedRestaurantId || !days) {
      setToast({ open: true, message: 'Selecione restaurante e informe days', severity: 'warning' });
      return;
    }
    setLoading((prev) => ({ ...prev, cmv: true }));
    const body = {
      days: Number(days),
      restaurantIds: [Number(selectedRestaurantId)]
    };
    axios
      .post(`${environments.dashBoard}/cmvView`, body, axiosConfig)
      .then(() => {
        setLoading((prev) => ({ ...prev, cmv: false }));
        // sessionStorage.setItem(CMV_KEY_BASE, String(Date.now()));
        setToast({ open: true, message: 'Reprocessamento CMV finalizado', severity: 'success' });
      })
      .catch((error) => {
        setLoading((prev) => ({ ...prev, cmv: false }));
        setToast({ open: true, message: error?.response?.data?.message || 'Erro ao reprocessar CMV', severity: 'error' });
      });
  };

  const handleOrderFix = () => {
    if (!selectedRestaurantId || !orderId) {
      setToast({ open: true, message: 'Selecione restaurante e informe orderId', severity: 'warning' });
      return;
    }
    setLoading((prev) => ({ ...prev, order: true }));
    const query = `${environments.orders}/orders/fix?numberOfDays=1&restaurantId=${Number(selectedRestaurantId)}&processNow=true&orderIds=${encodeURIComponent(orderId)}`;
    axios
      .get(query, axiosConfig)
      .then(() => {
        setLoading((prev) => ({ ...prev, order: false }));
        // sessionStorage.setItem(ORDER_KEY_BASE, String(Date.now()));
        setToast({ open: true, message: 'Reprocessamento do pedido finalizado', severity: 'success' });
      })
      .catch((error) => {
        setLoading((prev) => ({ ...prev, order: false }));
        setToast({ open: true, message: error?.response?.data?.message || 'Erro ao reprocessar pedido', severity: 'error' });
      });
  };

  const handleCosts = () => {
    if (!selectedRestaurantId || !dateStart || !dateEnd) {
      setToast({ open: true, message: 'Selecione restaurante e informe date e dateEnd', severity: 'warning' });
      return;
    }
    setLoading((prev) => ({ ...prev, costs: true }));
    const start = moment(dateStart).format('YYYY-MM-DD');
    const end = moment(dateEnd).format('YYYY-MM-DD');
    const query = `${environments.worker}/config/costs?restaurantId=${Number(selectedRestaurantId)}&date=${start}&dateEnd=${end}`;
    axios
      .get(query, axiosConfig)
      .then(() => {
        setLoading((prev) => ({ ...prev, costs: false }));
        // sessionStorage.setItem(COSTS_KEY_BASE, String(Date.now()));
        setToast({ open: true, message: 'Reprocessamento de custos finalizado', severity: 'success' });
      })
      .catch((error) => {
        setLoading((prev) => ({ ...prev, costs: false }));
        setToast({ open: true, message: error?.response?.data?.message || 'Erro ao reprocessar custos', severity: 'error' });
      });
  };

  if (!accessAllowed) {
    return (
      <Layout>
        <Container>
          <div style={{ padding: 16 }}>acesso não permitido</div>
        </Container>
      </Layout>
    );
  }

  return (
    <Layout>
      <Container>
        <Grid container justify="center" style={{ padding: 16 }}>
          <Grid item xs={12} md={10} lg={8}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Paper elevation={2} style={{ padding: 16 }}>
                  <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                    Seleção de Restaurante
                  </Typography>
                  <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} md={8}>
                      <Autocomplete
                        options={restaurants || []}
                        getOptionLabel={(option) => option?.name || option?.fantasyName || String(option?.id || '')}
                    getOptionSelected={(option, value) => String(option?.id) === String(value?.id)}
                        loading={loading.list}
                        size="small"
                    clearOnBlur={false}
                    disableClearable
                        value={selectedRestaurant || null}
                        onChange={(_, value) => setSelectedRestaurant(value || null)}
                        renderInput={(params) => (
                          <TextField {...params} label="Restaurante" variant="outlined" placeholder="Selecione..." />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Paper elevation={2} style={{ padding: 16 }}>
                  <Typography variant="subtitle1">
                    Reprocessar CMV
                  </Typography>
                  <Divider style={{ margin: '8px 0 16px' }} />
                  <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextField
                        label="Dias"
                        type="number"
                        fullWidth
                        value={days}
                        onChange={(e) => setDays(e.target.value)}
                        variant="outlined"
                        size="small"
                        inputProps={{ min: 1 }}
                        error={Boolean(days) && !isValidDays}
                        helperText={Boolean(days) && !isValidDays ? 'Informe um número maior que 0' : 'Informe a quantidade de dias'}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                      <Button color="primary" variant="contained" size="small" onClick={() => {
                        if (cmvRemainingMs > 0) {
                          const remaining = formatRemaining(cmvRemainingMs);
                          setToast({ open: true, message: `Aguarde ${remaining} para novo reprocessamento de CMV`, severity: 'warning' });
                          return;
                        }
                        handleCmv();
                      }} disabled={Boolean(loading.cmv) || !isValidRestaurant || !isValidDays || cmvRemainingMs > 0} fullWidth>
                        {loading.cmv ? <CircularProgress size={20} /> : 'Reprocessar CMV'}
                      </Button>
                      {cmvRemainingMs > 0 && (
                        <Typography variant="caption" style={{ display: 'block', marginTop: 6, color: '#6b7280' }}>
                          Disponível em {formatRemaining(cmvRemainingMs)}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Paper elevation={2} style={{ padding: 16 }}>
                  <Typography variant="subtitle1">
                    Reprocessar Pedido
                  </Typography>
                  <Divider style={{ margin: '8px 0 16px' }} />
                  <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TextField
                        label="ID do Pedido"
                        fullWidth
                        value={orderId}
                        onChange={(e) => setOrderId(e.target.value)}
                        variant="outlined"
                        size="small"
                        helperText="Informe o ID do pedido"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                      <Button color="primary" variant="contained" size="small" onClick={() => {
                        if (orderRemainingMs > 0) {
                          const remaining = formatRemaining(orderRemainingMs);
                          setToast({ open: true, message: `Aguarde ${remaining} para novo reprocessamento de Pedido`, severity: 'warning' });
                          return;
                        }
                        handleOrderFix();
                      }} disabled={Boolean(loading.order) || !isValidRestaurant || !isValidOrderId || orderRemainingMs > 0} fullWidth>
                        {loading.order ? <CircularProgress size={20} /> : 'Reprocessar Pedido'}
                      </Button>
                      {orderRemainingMs > 0 && (
                        <Typography variant="caption" style={{ display: 'block', marginTop: 6, color: '#6b7280' }}>
                          Disponível em {formatRemaining(orderRemainingMs)}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Paper elevation={2} style={{ padding: 16 }}>
                  <Typography variant="subtitle1">
                    Reprocessar Custos
                  </Typography>
                  <Divider style={{ margin: '8px 0 16px' }} />
                  <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                      <TextField
                        label="Data inicial"
                        type="date"
                        fullWidth
                        value={dateStart}
                        onChange={(e) => setDateStart(e.target.value)}
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                      <TextField
                        label="Data final"
                        type="date"
                        fullWidth
                        value={dateEnd}
                        onChange={(e) => setDateEnd(e.target.value)}
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                      <Button color="primary" variant="contained" size="small" onClick={() => {
                        if (costsRemainingMs > 0) {
                          const remaining = formatRemaining(costsRemainingMs);
                          setToast({ open: true, message: `Aguarde ${remaining} para novo reprocessamento de Custos`, severity: 'warning' });
                          return;
                        }
                        handleCosts();
                      }} disabled={Boolean(loading.costs) || !isValidRestaurant || !isValidDateRange || costsRemainingMs > 0} fullWidth>
                        {loading.costs ? <CircularProgress size={20} /> : 'Reprocessar Custos'}
                      </Button>
                      {costsRemainingMs > 0 && (
                        <Typography variant="caption" style={{ display: 'block', marginTop: 6, color: '#6b7280' }}>
                          Disponível em {formatRemaining(costsRemainingMs)}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Snackbar
          open={toast.open}
          autoHideDuration={5000}
          onClose={() => setToast({ ...toast, open: false })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert
            onClose={() => setToast({ ...toast, open: false })}
            severity={toast.severity}
            elevation={3}
            variant="standard"
            style={{
              background: toast.severity === 'success' ? '#e8f5e9' : toast.severity === 'error' ? '#fdecea' : '#f7f9fc',
              color: toast.severity === 'success' ? '#1b5e20' : toast.severity === 'error' ? '#7f1d1d' : '#1f2937',
              border: '1px solid #e5e7eb'
            }}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      </Container>
    </Layout>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

export default connect(mapStateToProps)(BackOfficeV2);


